module.exports = __webpack_public_path__ + "static/media/Seminarios-para-empresas.41ba6a58.JPG";